import React, { Component, Fragment } from 'react';
import { Segment, Header, Form, Grid, Loader, Button, Popup, Input } from 'semantic-ui-react';
import {
    fetchCountries,
    fetchGenderName,
} from '../../Lookups/util';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import axios from 'axios';
import { toast } from 'react-toastify';

class NonCycleStudentPersonalInformationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            genderOptions: [],
            countryOptions: [],
            personOptions: [],
            loadingOptions: true,
        };
    }

    componentDidMount() {
        Promise.all([
            fetchGenderName(),
            fetchCountries(),
        ])
            .then(([genders, countries]) => {
                this.setState({
                    genderOptions: genders.data.map((el) => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    countryOptions: countries.data.map((el) => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    })),
                    loadingOptions: false
                });
            });
    }

    fetchPersons = () => {
        const {
            personFirstName,
            personLastName,
            personJmbg
        } = this.props.student;

        if (!personFirstName || !personLastName) {
            toast(<FormattedMessage id="externalStudent.toast.firstAndLastNameRequired"/>);
            return; // Do not fetch if required fields are missing
        }

        this.setState({
            loadingPersonOptions: true,
            personOptions: []
        });
        this.props.onChangeStudent({ person: null }); // Clear selected person when fetching new options
        axios.post(`/non-cycle-student/persons`, {
            firstName: personFirstName,
            lastName: personLastName,
            jmbg: personJmbg
        })
            .then(res => {
                this.setState({
                    personOptions: res.data.map((el) => ({
                        key: el.id,
                        value: el,
                        text: `${el.firstName} ${el.lastName} (${el.jmbg})`
                    })),
                    loadingPersonOptions: false
                });
            })
            .catch(() => {
                this.setState({ loadingPersonOptions: false });
            });
    };

    fillStudentPersonalInformation = (person) => {
        const { onChangeStudent } = this.props;
        if (person) {
            onChangeStudent({
                firstName: person.firstName,
                lastName: person.lastName,
                jmbg: person.jmbg,
                gender: person.gender,
                email: person.email,
                dateOfBirth: person.dateOfBirth,
                birthPlaceName: person.placeOfBirth.name,
                birthCountry: person.placeOfBirth.country,
            });
        }
    };

    render() {
        const {
            genderOptions,
            countryOptions,
            loadingOptions,
            personOptions,
        } = this.state;
        const {
            onSave,
            onCancel,
            onChangeStudent,
            student,
            errors
        } = this.props;

        return (
            <Grid.Column>
                <Segment.Group>
                    <Segment>
                        <Header.Content as="h3">
                            <FormattedMessage id="externalStudent.personalData"/>
                            {(this.props.edit && !loadingOptions) &&
                                <Fragment>
                                    <Popup
                                        content={<FormattedMessage id="externalStudent.cancel"/>}
                                        position="top center"
                                        trigger={<Button
                                            floated="right"
                                            icon="cancel"
                                            basic
                                            color="red"
                                            circular
                                            size="mini"
                                            disabled={loadingOptions}
                                            onClick={() => {
                                                onCancel();
                                            }}
                                        />}
                                    />
                                    <Popup
                                        content={<FormattedMessage id="externalStudent.edit"/>}
                                        position="top center"
                                        trigger={<Button
                                            floated="right"
                                            icon="check"
                                            basic
                                            color="green"
                                            circular
                                            size="mini"
                                            disabled={loadingOptions}
                                            onClick={() => {
                                                onSave(student);
                                            }}
                                        />}
                                    />
                                </Fragment>
                            }
                            {(!this.props.edit && !loadingOptions) &&
                                <Popup
                                    content={this.state.showAddExistingStudent ?
                                        <FormattedMessage id="externalStudent.cancel"/> :
                                        <FormattedMessage id="externalStudent.connectExistingStudent"/>}
                                    position="top center"
                                    trigger={<Button
                                        floated="right"
                                        icon={this.state.showAddExistingStudent ? 'cancel' : 'user plus'}
                                        basic
                                        color={this.state.showAddExistingStudent ? 'red' : 'blue'}
                                        circular
                                        size="mini"
                                        disabled={loadingOptions}
                                        onClick={() => {
                                            this.setState({ showAddExistingStudent: !this.state.showAddExistingStudent });
                                        }}
                                    />}
                                />
                            }
                        </Header.Content>
                    </Segment>
                    {this.state.showAddExistingStudent &&
                        <Segment secondary>
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Field required error={errors.firstNameErr}>
                                        <label><FormattedMessage id="externalStudent.firstName"/></label>
                                        <FormattedMessage id="externalStudent.enterFirstName">
                                            {msg => (
                                                <Input
                                                    placeholder={msg}
                                                    value={student.personFirstName || ''}
                                                    onChange={(e, { value }) => onChangeStudent({ personFirstName: value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field required error={errors.lastNameErr}>
                                        <label><FormattedMessage id="externalStudent.lastName"/></label>
                                        <FormattedMessage id="externalStudent.enterLastName">
                                            {msg => (
                                                <Input
                                                    placeholder={msg}
                                                    value={student.personLastName || ''}
                                                    onChange={(e, { value }) => onChangeStudent({ personLastName: value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field error={errors.jmbgErr}>
                                        <label><FormattedMessage id="externalStudent.jmbgAlt"/></label>
                                        <FormattedMessage id="externalStudent.enterJmbgAlt">
                                            {msg => (
                                                <Input
                                                    placeholder={msg}
                                                    value={student.personJmbg || ''}
                                                    onChange={(e, { value }) => onChangeStudent({ personJmbg: value })}
                                                />
                                            )}
                                        </FormattedMessage>
                                    </Form.Field>
                                    <Form.Field width={1}>
                                        <label>&nbsp;</label>
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.findStudent"/>}
                                            position="top center"
                                            trigger={<Form.Button
                                                floated="right"
                                                icon="search"
                                                basic
                                                color="blue"
                                                circular
                                                size="mini"
                                                loading={this.state.loadingPersonOptions}
                                                disabled={this.state.loadingPersonOptions}
                                                onClick={() => {
                                                    this.fetchPersons();
                                                }}
                                            />}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Field>
                                    <label><FormattedMessage id="externalStudent.student"/></label>
                                    <Form.Dropdown
                                        search
                                        options={personOptions}
                                        value={student.person || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectStudent"/>}
                                        disabled={personOptions.length === 0}
                                        onChange={(e, { value }) => {
                                            this.fillStudentPersonalInformation(value);
                                            onChangeStudent({ person: value });
                                        }}
                                    />
                                </Form.Field>
                            </Form>
                        </Segment>
                    }
                    <Segment>
                        {loadingOptions ? (
                            <div style={{
                                paddingTop: '100px',
                                paddingBottom: '100px'
                            }}
                            ><Loader active inline="centered"/></div>
                        ) : (
                            <Form>
                                <Form.Field required error={errors.firstNameErr}>
                                    <label><FormattedMessage id="externalStudent.firstName"/></label>
                                    <FormattedMessage id="externalStudent.enterFirstName">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.firstName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ firstName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required error={errors.lastNameErr}>
                                    <label><FormattedMessage id="externalStudent.lastName"/></label>
                                    <FormattedMessage id="externalStudent.enterLastName">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.lastName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ lastName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field error={errors.emailErr}>
                                    <label><FormattedMessage id="externalStudent.email"/></label>
                                    <FormattedMessage id="externalStudent.enterEmail">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.email || ''}
                                                onChange={(e, { value }) => onChangeStudent({ email: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required error={errors.jmbgErr}>
                                    <label><FormattedMessage id="externalStudent.jmbgAlt"/></label>
                                    <FormattedMessage id="externalStudent.enterJmbgAlt">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.jmbg || ''}
                                                onChange={(e, { value }) => onChangeStudent({ jmbg: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.gender"/></label>
                                    <Form.Dropdown
                                        search
                                        options={genderOptions}
                                        value={student.gender || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectGender"/>}
                                        onChange={(e, { value }) => onChangeStudent({ gender: value })}
                                        error={errors.genderErr}
                                    />
                                </Form.Field>

                                <Form.Field required error={errors.dateOfBirthErr}>
                                    <label><FormattedMessage id="externalStudent.birthDate"/></label>
                                    <FormattedMessage id="externalStudent.enterBirthDate">
                                        {msg => (
                                            <DateTimePicker
                                                format="D. M. YYYY."
                                                time={false}
                                                placeholder={msg}
                                                value={student.dateOfBirth ? new Date(student.dateOfBirth) : null}
                                                onChange={(value) => onChangeStudent({ dateOfBirth: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required error={errors.birthPlaceNameErr}>
                                    <label><FormattedMessage id="externalStudent.birthPlaceName"/></label>
                                    <FormattedMessage id="externalStudent.enterBirthPlaceName">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.birthPlaceName || ''}
                                                onChange={(e, { value }) => onChangeStudent({ birthPlaceName: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.birthCountry"/></label>
                                    <Form.Dropdown
                                        search
                                        options={countryOptions}
                                        value={student.birthCountry || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectBirthCountry"/>}
                                        onChange={(e, { value }) => onChangeStudent({ birthCountry: value })}
                                        error={errors.countryErr}
                                    />
                                </Form.Field>
                            </Form>
                        )}
                    </Segment>
                </Segment.Group>
            </Grid.Column>
        );
    }
}

export default NonCycleStudentPersonalInformationForm;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentForms/NonCycleStudentPersonalInformationForm.js